export default "__VITE_ASSET__BSclki2X__"